export function disableMonthlyRadio(event) {
	
	const clickedTab = event.target.closest('a');
	const radioMonthly = document.querySelector('input[value="Monthly"]');
	const radioOneTime = document.querySelector('input[value="One Time"]');
	
	if (clickedTab.dataset.paymentmethod === "paypal") {
		radioOneTime.checked = true;
		radioMonthly.disabled = true;
		radioMonthly.parentElement.classList.add('disabled');
	} else {
		radioMonthly.disabled = false;
		radioMonthly.parentElement.classList.remove('disabled');
	}

}
